import { ITranslationFunction } from '../../../shared/i18n/translate';
import { ONE_DAY_BOOKING } from '../constants';

export function getDaysInTotalDetails(
	daysInTotal: number,
	t: ITranslationFunction,
): string {
	return `(${daysInTotal} ${
		daysInTotal > ONE_DAY_BOOKING
			? t('web_parking_booking_summary_booked_days_label')
			: t('web_parking_booking_summary_booked_day_label')
	})`;
}
